import katex from "katex"

export const CAGR = katex.renderToString("\\Large \\left( \\frac{\\text{Cum. Distribution}}{\\text{Cum. Contribution}} \\right)^{\\frac{1}{n}} - 1")

export const DPI = katex.renderToString("\\Large \\frac{\\text{Cum. Distribution}}{\\text{Cum. Contribution}}")

export const IRR = katex.renderToString("\\Large \\sum_{t=0}^{M} \\frac{v_t}{(1 + irr)^t} = 0")
